import React, { useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "./Navbar";
import Header from "./header";
import { useLanguage } from "../../common/i18n/LanguageContext";
import CurrencyTab from "./PageComponents/Settings/CurrencyTab";

// To add another settings tab: add one { key, label, Component } entry here
// — Settings.jsx itself (the tab bar, page layout) never needs to change.
const useSettingsTabs = (t) => [
  {
    key: "currency",
    label: t("settings_tab_currency"),
    Component: CurrencyTab,
  },
];

function Settings() {
  const { t } = useLanguage();
  const pos = localStorage.getItem("position");
  const TABS = useSettingsTabs(t);
  const [activeTab, setActiveTab] = useState(TABS[0]?.key);

  const ActiveComponent = TABS.find((tab) => tab.key === activeTab)?.Component;

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <div className="shrink-0">
        <Navbar />
      </div>
      <div className="flex flex-1 overflow-hidden items-start">
        <div className="shrink-0 overflow-y-auto h-full">
          <Sidebar pos={pos} />
        </div>
        <div className="flex flex-col flex-1 max-h-full overflow-hidden">
          <div className="shrink-0">
            <Header title={t("menu_settings")} />
          </div>
          <div className="flex-1 overflow-y-auto p-2 space-y-2">
            <div className="flex items-center gap-1 bg-white p-2 rounded-lg shadow-sm">
              {TABS.map((tab) => (
                <button
                  key={tab.key}
                  type="button"
                  onClick={() => setActiveTab(tab.key)}
                  className={`px-3 py-1 rounded text-sm font-bold ${
                    activeTab === tab.key
                      ? "bg-brand-blue-600 text-white"
                      : "text-slate-600 hover:bg-slate-100"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
            {ActiveComponent && <ActiveComponent />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Settings;
